import { QRFC } from "./QRFC";

export class QGetMissingImage extends QRFC {
  constructor() {
    super();
  }

  InitMissingPic(callbackObj) {
    this.InitRemoteCall(callbackObj, "POST", true, false);
  }

  GetCallName() {
    return "qgetmissingimage";
  }

  SetParams(org) {
    this.AddEncodedParameter("org", org);
  }

  DoTransactionComplete(response, callBackObj) {
    var r = response;
    callBackObj.MissingPicResult(response);
  }
}
